module.exports = __webpack_public_path__ + "static/media/transferenciaIcon.7bd88587.svg";